import { base44 } from "@/api/base44Client";

export const KG_TO_LBS = 2.20462;
export const CM_TO_IN = 0.393701;

export async function saveUnitPrefs({ useLbs, useInches }) {
  const update = {};
  if (useLbs !== undefined) update.use_lbs = useLbs;
  if (useInches !== undefined) update.use_inches = useInches;
  await base44.auth.updateMe(update);
}

/** Derive display unit prefs from a user object (falls back to lbs/inches) */
export function getUnitPrefs(user) {
  const useLbs = user?.use_lbs !== false; // default true
  const useInches = user?.use_inches !== false; // default true
  return { useLbs, useInches };
}